import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found.component';
import { AuthGuardGuard } from './core/guards/auth-guard.guard';
import { IndexComponent } from './modules/landing-page/pages/index/index.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/landing-page/landing-page.module').then(m => m.LandingPageModule),
    canActivate: [AuthGuardGuard]
  },
  {
    path: "verification",
    loadChildren: () =>
      import(
        "./modules/verification/verification.module"
      ).then((m) => m.VerificationModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
    },
    {
    path: 'login/:userByOrganization',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
    },
    { path: 'login/:userByOrganization', component: IndexComponent },

  {
    path: 'register',
    loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule)
  },
  {
    path: '',
    loadChildren: () => import('./modules/landing-page/landing-page.module').then(m => m.LandingPageModule),
    canActivate: [AuthGuardGuard]
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
